export default {
    props: ['name', 'initialValue', 'propertyInForm', 'parentValues'],
    data() {
        return {
            value: this.initialValue,
        }
    },
    methods: {
        getValue() {
            return this.value;
        },
    },
    watch: {
        value(newVal, oldVal) {
            this.$emit('valueChanged', newVal, oldVal, this.propertyInForm);
        }
    }

}
